import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, BoxExtendedProps, Text, useResponsive } from '@common-fe/common-fe';

import { PaymentOrder } from '@/modules/UseMyMoney/components';
import { useDocumentOcrStore } from '@/modules/UseMyMoney/stores';

interface Props extends BoxExtendedProps {
  isLoading?: boolean;
}

const ClaimSummaryPaymentOrder: React.FC<Props> = ({ isLoading, ...props }) => {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();
  const { ocrDocument } = useDocumentOcrStore();

  return (
    <Box {...props}>
      <Text weight={700}>
        {t('Payment order')}
      </Text>

      <PaymentOrder
        margin={{ top: 'spacing8' }}
        accountOrders={ocrDocument?.availableAccounts}
        isLoading={isLoading}
        isMobile={isMobile}
      />
    </Box>
  );
};

export default ClaimSummaryPaymentOrder;
